import { Button, ButtonProps } from "antd";
import React, { FC } from "react";
import { useNavigate } from "react-router-dom";

interface ButtonLinkProps extends ButtonProps {
  to: string;
}

const ButtonLink: FC<ButtonLinkProps> = ({ children, to, ...props }) => {
  const navigate = useNavigate();
  const handleClick = () => navigate(to);

  return (
    <Button {...props} onClick={handleClick}>
      {children}
    </Button>
  );
};

export default ButtonLink;
